var topspot = 1800;

if ( $('.leaderboard-sticky').length ) {
  $(".sticky-top").css("top", "180px");

  if($(window).scrollTop() > ( topspot  )){
    $(".header-container").addClass("reset");
    $(".sticky-top").css("top" , "50px");
  }
  
  $(window).scroll(function(){
    
      if($(window).scrollTop() > ( topspot )){
         $(".header-container").addClass("animate").delay(300).addClass("reset").removeClass("animate");;
         $(".sticky-top").css("top" , "50px");
      }
  
  });
}
